/**
 * BIL Store Locator analytics bridge.
 *
 * Emits privacy-aware custom events through three safe channels:
 * 1) Shopify Customer Events: Shopify.analytics.publish(...)
 * 2) Direct GA4, when Shopify/Google exposes window.gtag
 * 3) dataLayer for a future GTM setup
 *
 * Event naming is intentionally concise for GA4. Details live in payload fields.
 */
(function (window, document) {
  'use strict';

  var EVENT_PREFIX = 'bil_locator_';

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (error) {
      // Never block the locator if Shopify's privacy API is unavailable.
    }
    return true;
  }

  function cleanValue(value) {
    if (value === undefined || value === null || value === '') return undefined;
    if (typeof value === 'string') return value.slice(0, 100);
    return value;
  }

  function cleanPayload(payload) {
    var source = payload || {};
    var allowed = [
      'action', 'filter_type', 'search_term', 'search_type', 'selected_state',
      'selected_region', 'selected_retailer', 'result_count',
      'store_id', 'store_name', 'retailer', 'city', 'state',
      'zip', 'origin_type', 'locator_version'
    ];
    var clean = {};
    allowed.forEach(function (key) {
      var value = cleanValue(source[key]);
      if (value !== undefined) clean[key] = value;
    });
    clean.locator_version = '1.1.0';
    return clean;
  }

  /**
   * trackStoreLocatorEvent(action, payload)
   * Example: trackStoreLocatorEvent('search', { search_type: 'zip', ... })
   */
  function trackStoreLocatorEvent(action, payload) {
    if (!action || !analyticsAllowed()) return;

    var eventName = EVENT_PREFIX + action;
    var data = cleanPayload(payload);
    data.action = action;

    // Shopify custom events are the durable in-store integration point.
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('bil:store_locator:' + action, data);
      }
    } catch (error) {
      // Shopify analytics is optional. Keep the locator operational.
    }

    // Direct GA4. Do NOT also push a duplicate event to dataLayer if gtag exists.
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, data);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: eventName }, data));
      }
    } catch (error) {
      // Analytics should never break customer experience.
    }

    try {
      document.dispatchEvent(new CustomEvent('bil:store-locator:' + action, {
        detail: Object.assign({ event_name: eventName }, data)
      }));
    } catch (error) {
      // Safe fallback for old browsers.
    }

    if (window.BIL_STORE_LOCATOR_DEBUG) {
      console.info('[BIL Locator analytics]', eventName, data);
    }
  }

  window.trackStoreLocatorEvent = trackStoreLocatorEvent;
})(window, document);
